import { createPaymentMethodsContainer } from './container'
import { PaymentMethods as PaymentMethodsUI } from './ui/payment-methods'

export const PaymentMethods = createPaymentMethodsContainer(PaymentMethodsUI)
